export const MOTIVATION_QUESTION = `What's your biggest motivation right now?`

export const MOTIVATION_OPTIONS = [
  { key: 'careerGrowth', i18nKey: 'careerGrowth' },
  { key: 'betterRelationships', i18nKey: 'betterRelationships' },
  { key: 'moreConfidence', i18nKey: 'moreConfidence' },
  { key: 'personalGrowth', i18nKey: 'personalGrowth' },
  { key: 'financialSuccess', i18nKey: 'financialSuccess' },
  { key: 'buildNewFriendships', i18nKey: 'buildNewFriendships' },
  { key: 'otherPersonalGoal', i18nKey: 'otherPersonalGoal' },
] as const
